import { render, staticRenderFns } from "./registre-patient.html?vue&type=template&id=5a9f61c5&scoped=true&external"
import script from "./registre-patient.js?vue&type=script&lang=js&external"
export * from "./registre-patient.js?vue&type=script&lang=js&external"
import style0 from "./registre-patient.scss?vue&type=style&index=0&id=5a9f61c5&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9f61c5",
  null
  
)

export default component.exports